import { KText, KView } from '@/component/RtlLayout';
import React from 'react';
import { convertStyles } from '@kibt/krn-utils';
import SrcStyles from './index.styl';
import { scaleW } from '@/common/style';
import { ViewStyle } from 'react-native';

const Styles = convertStyles(SrcStyles);
/** 商品打标, 复用 tags 字段，打标取值类型为：tags[index].tagLabel === 9999 */
const IconText = (itemPorps: {
    titleLine?: number; // 同品低价参数 0,1，2;为0时不展示 title 包括tabs
    source?: string;
    /** 来源类型，分为 merchant 和 shopcard */
    sourceType?: 'merchant' | 'shopcard'; // shopcard 一般不传
    /** 默认样式：DEFAULT，紧凑样式：COMPACT */
    mode?: string;
    /** 标题 */
    title: string;
    /** 标签列表 */
    tagList?: {
        /** 正品商家："merchant_official"，平台推荐商家："merchant_platformReco" */
        tagCode?: 'merchant_official' | 'merchant_platformReco';
        /** 标签文案，本次打标文案由后端返回 */
        tips?: string;
        /** 标签类型 */
        tagLabel?: number; // 1,2,3,4,5,9999
    }[];
    customerContainerStyle?: ViewStyle;
    customerTagStyle?: ViewStyle;
}) => {
    // 标签列表
    const _tags = itemPorps?.tagList?.filter(_item => _item.tagLabel === 9999).slice(0, 1) || [];
    // console.log('_tags', _tags);
    // 默认样式：DEFAULT，紧凑样式：COMPACT
    const mode = itemPorps.mode || 'DEFAULT';

    const source = itemPorps.source || '';

    const sourceType = itemPorps.sourceType || '';

    const customerTagStyle = itemPorps.customerTagStyle || {};
    const customerContainerStyle = itemPorps.customerContainerStyle || {};
    // 标题样式
    // const styleTextOfTitle = itemPorps.styleTextOfTitle || {};
    // const _tags = [
    //     {
    //         tips: 'jhjkhjhjh',
    //         tagCode: 'merchant_official',
    //     },
    // ];

    /** 占位字符 */
    const getHiddenText = (tips?: string) => {
        if (!tips) {
            return '';
        }
        // 如果text是中文，占位符用英文字母代替，因为中文会换行
        // eslint-disable-next-line no-control-regex
        const text = tips?.replace(/[^\x00-\xff]/g, '11');
        return `${text}xxxx`;
    };
    return (
        <>
            {/* 只有当实验参数为0时，才不展示标题；没有实验或实验参数不为0时，正常展示。确保其他用这个组件的地方不会受影响 */}
            {itemPorps.titleLine !== 0 ? (
                <KView
                    className={
                        mode === 'DEFAULT'
                            ? Styles[
                                  `product-title${
                                      sourceType === 'merchant' && (source === 'detail' || source === 'merchant') ? '_detail_merchant' : ''
                                  }`
                              ]
                            : Styles['product-title__compact']
                    }
                    style={customerContainerStyle}>
                    {_tags.map(_item => {
                        return (
                            _item?.tips && (
                                <KView
                                    className={Styles['pruduct-shippingIncluded']}
                                    style={{
                                        backgroundColor: _item.tagCode === 'merchant_official' ? '#3A3A3A' : '#FF4906',
                                        ...(source === 'same-product'
                                            ? {
                                                  fontSize: scaleW(12),
                                                  position: 'absolute',
                                                  top: 2,
                                              }
                                            : sourceType === 'merchant'
                                            ? {
                                                  top: 3,
                                              }
                                            : {
                                                  top: 4,
                                              }),
                                        ...customerTagStyle,
                                    }}>
                                    <KText
                                        style={{
                                            color: _item.tagCode === 'merchant_official' ? '#FFF0A1' : '#FFFFFF',
                                            fontSize: scaleW(9),
                                            paddingHorizontal: 2,
                                            fontWeight: 'bold',
                                        }}
                                        rtlClassName={'pruduct-shippingIncluded-text'}>
                                        {_item.tips}
                                    </KText>
                                </KView>
                            )
                        );
                    })}

                    <KText
                        //实验参数优先; 原逻辑 sourceType === 'merchant' ? 1 : 2
                        numberOfLines={itemPorps.titleLine ?? (sourceType === 'merchant' ? 1 : 2)}
                        style={[
                            {
                                fontSize: scaleW(sourceType === 'merchant' && source === 'detail' ? 18 : 14),
                                color: 'rgba(0, 0, 0, 1)',
                            },
                            sourceType === 'merchant'
                                ? {
                                      maxWidth: 280,
                                  }
                                : {},
                        ]}
                        ellipsizeMode={'tail'}
                        rtlClassName={mode === 'DEFAULT' ? 'product-title-text' : 'product-title-text__compact'}>
                        {/* 沿用之前的技术实现方式，此处表示占位 */}
                        {_tags.map(_item => {
                            return (
                                <KText
                                    rtlClassName={'pruduct-shippingIncluded-text-hidden'}
                                    style={{"color":"rgba(0, 0, 0, 0)","fontSize":"2.173913043478261rem"}}>
                                    {getHiddenText(_item.tips)}
                                </KText>
                            );
                        })}
                        {itemPorps.title}
                    </KText>
                </KView>
            ) : null}
        </>
    );
};

export default IconText;
